import { render, staticRenderFns } from "./ruleTempAbnormal.vue?vue&type=template&id=c8810df2&scoped=true"
import script from "./ruleTempAbnormal.vue?vue&type=script&lang=js"
export * from "./ruleTempAbnormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8810df2",
  null
  
)

export default component.exports